import React from 'react'
import {Image} from 'react-bootstrap'
import {Link} from 'react-router'

import './CubeLink.css'

class CubeLink extends React.Component {
  render () {
    const {target} = this.props
    return (
      <Link to={target.path} className="CubeLink">
        <div className="AvatarBox">
          {target.icon && target.icon}
          {target.image && <Image src={target.image} alt={target.name} className="Avatar" />}
        </div>
        <div className="InfoBox">
          <h3 className="Name">{target.name}</h3>
          <p className="Description">{target.description}</p>
        </div>
      </Link>
    )
  }
}

CubeLink.propTypes = {
  target: React.PropTypes.object
}

export default CubeLink



// WEBPACK FOOTER //
// ./src/components/User/Dashboard/CubeLink.js